export var DomainSsoEnforcement;
(function (DomainSsoEnforcement) {
    DomainSsoEnforcement["DISABLED"] = "disabled";
    DomainSsoEnforcement["OPTIONAL"] = "optional";
    DomainSsoEnforcement["REQUIRED"] = "required";
})(DomainSsoEnforcement || (DomainSsoEnforcement = {}));
